<script>
    import axios from '../../setup/axios';

    export default {
        components: {
            GatedContentForm: () => import('../gated-content/GatedContentForm.vue'),
            Modal: () => import('../modal/Modal.vue'),
        },

        data() {
            return {
                isDialogOpen: false,

                user: {
                    name: null,
                    email: null,
                },
                documentId: null,
                dlfileentry_type_name: null,
                groupId: null,
                uuid: null,

                busy: false,
                isDownload: false,
                isForbidden: false,
                isGatedContent: false,
                requestSent: false,
                requestError: false,
            };
        },

        computed: {
            isSignedIn() {
                return window.Liferay.ThemeDisplay.isSignedIn();
            },

            loginUrl() {
                return `${location.protocol}//${location.host}${location.pathname}?p_p_id=com_liferay_login_web_portlet_LoginPortlet&p_p_lifecycle=0&p_p_state=maximized&p_p_mode=view&saveLastPath=false&_com_liferay_login_web_portlet_LoginPortlet_mvcRenderCommandName=%2Flogin%2Flogin`;
            },
        },

        mounted() {
            document.addEventListener('requests-document-download', this.handleDomEvent);
            this.$bus.on('requests-document-download', this.handleBusEvent);

            if (this.isSignedIn === true) {
                this.user.name = window.Liferay.ThemeDisplay.getUserName();
                this.user.email = window.Liferay.ThemeDisplay.getUserEmailAddress();
            }
        },

        beforeDestroy() {
            document.removeEventListener('requests-document-download', this.handleDomEvent);
        },

        methods: {
            openDialog() {
                this.isDialogOpen = true;
            },

            closeDialog(event) {
                this.isDialogOpen = false;
            },

            handleDomEvent(event) {
                this.documentId = event.detail.documentId;
                this.dlfileentry_type_name = event.detail.dlfileentry_type_name;
                this.groupId = event.detail.groupId;
                this.uuid = event.detail.uuid;

                this.handleDownloadRequest();
            },

            handleBusEvent({ documentId, dlfileentry_type_name, groupId, uuid }) {
                this.documentId = documentId;
                this.dlfileentry_type_name = dlfileentry_type_name;
                this.groupId = groupId;
                this.uuid = uuid;
                this.handleDownloadRequest();
            },

            handleDownloadRequest() {
                if (this.busy !== false) {
                    return;
                }
                this.busy = true;

                this.isDownload = false;
                this.isForbidden = false;
                this.requestSent = false;

                if (
                    typeof this.dlfileentry_type_name !== 'undefined' &&
                    this.dlfileentry_type_name === 'Gated Content'
                ) {
                    this.isGatedContent = true;
                    this.busy = false;
                    return this.openDialog();
                }

                if (this.isSignedIn !== true) {
                    this.busy = false;
                    return this.openDialog();
                }

                axios
                    .get(`/o/download-server/document-download/check-download/${this.documentId}`)
                    .then(response => {
                        this.isDownload = true;
                        window.location.replace(response.data.downloadURL);
                    })
                    .catch(error => {
                        console.error(error);
                        if (error.response && error.response.data.reason !== 'permission required') {
                            this.isForbidden = true;
                        }
                    })
                    .finally(() => {
                        this.busy = false;
                        this.openDialog();
                    });
            },

            sendAccessRequest() {
                if (this.busy !== false) {
                    return;
                }
                this.busy = true;

                axios
                    .get(`/o/download-server/download-permission-request/request/${this.documentId}`)
                    .then(response => {
                        console.log(response);
                    })
                    .catch(error => {
                        console.error(error);
                        if (
                            error.response &&
                            (error.response.data === 'no request created - pending request already exists' ||
                                error.response.data === 'no request created - download permission denied')
                        ) {
                            this.requestError = true;
                        }
                    })
                    .finally(() => {
                        this.busy = false;
                        this.requestSent = true;
                    });
            },
        },
    };
</script>

<template>
    <div>
        <Modal
            v-if="isDialogOpen && isSignedIn && !isGatedContent"
            name="document-download-request-modal"
            :open="isDialogOpen"
            :has-header="!isDownload"
            :has-footer="false"
            @close="closeDialog"
        >
            <template slot="header">
                <h3>{{ $t('ddl.requestAccess') }}</h3>
            </template>

            <template v-if="isDownload && !isForbidden">
                <div class="text-center">
                    <p>
                        <span class="icon">
                            <svg
                                width="100px"
                                height="100px"
                                viewBox="0 0 100 100"
                                xmlns="http://www.w3.org/2000/svg"
                                xmlns:xlink="http://www.w3.org/1999/xlink"
                            >
                                <g transform="scale(4.16667)">
                                    <path
                                        fill="none"
                                        stroke="#58656D"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1"
                                        d="M19,5.5c0.55,0 0.682,0.318 0.293,0.707l-6.586,6.586l4.18572e-08,-4.18445e-08c-0.3905,0.390382 -1.0235,0.390382 -1.414,8.3689e-08l-6.586,-6.586c-0.389,-0.389 -0.257,-0.707 0.293,-0.707Z"
                                    />
                                    <path
                                        fill="none"
                                        stroke="#58656D"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="1"
                                        d="M0.5,18.5h23"
                                    />
                                </g>
                            </svg>
                        </span>
                    </p>
                    <p>{{ $t('ddl.downloading') }}&hellip;</p>
                </div>
            </template>
            <template v-else-if="isForbidden">
                <div class="text-center">
                    <p>
                        <strong>{{ $t('ddl.noAccess') }}</strong>
                    </p>
                    <p>{{ $t('ddl.errorError') }}: <a href="mailto:support@ams.com">support@ams.com</a></p>
                </div>
            </template>
            <template v-else>
                <template v-if="requestSent">
                    <template v-if="requestError">
                        <p class="text-center">
                            <strong>{{ $t('ddl.errorSubmitting') }}</strong
                            ><br />
                            {{ $t('ddl.noMoreRequests') }}
                        </p>
                    </template>
                    <template v-else>
                        <p class="text-center">
                            <strong>{{ $t('ddl.requestSuccess') }}</strong>
                            {{ $t('ddl.weNeedMoreTime') }}
                        </p>
                    </template>
                </template>
                <template v-else>
                    <p class="text-center">{{ $t('ddl.needsRequest') }}:</p>

                    <div class="form-actions text-center">
                        <button
                            class="button button--primary button--large"
                            :disabled="busy"
                            @click.prevnet="event => sendAccessRequest()"
                        >
                            {{ $t('ddl.requestAccess') }}
                        </button>
                    </div>
                </template>
            </template>
        </Modal>

        <Modal
            v-if="isDialogOpen && !isSignedIn && !isGatedContent"
            name="document-download-info-modal"
            :open="isDialogOpen"
            :has-footer="false"
            @close="closeDialog"
        >
            <template slot="header">
                <h3>{{ $t('ddl.accessRequired') }}</h3>
            </template>

            <div class="text-center">
                <p>
                    {{ $t('ddl.needsRequestShort') }}
                </p>
                <p>
                    <strong>{{ $t('ddl.login') }}</strong> {{ $t('ddl.register') }}.
                </p>
                <p>
                    <a class="button button--primary button--large" :href="loginUrl">
                        {{ $t('ddl.signup') }}
                    </a>
                </p>
            </div>
        </Modal>

        <GatedContentForm
            v-if="isDialogOpen && isGatedContent"
            name="document-download-info-modal"
            :open="isDialogOpen"
            :has-footer="false"
            :document-id="documentId"
            :group-id="groupId"
            :uuid="uuid"
            @close="closeDialog"
        >
        </GatedContentForm>
    </div>
</template>
